// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__3cAtj","searchTerm":"search_searchTerm__pIU2p"};